import { CampaignDetails } from '@features/campaigns/shared/types/campaign.ts';
import { ValueOf } from '@shared/types/common.ts';

export const ThematicPackageBudgetTierIds = {
  TIER_1: 'tier1',
  TIER_2: 'tier2',
  TIER_3: 'tier3',
} as const;

export type ThematicPackageBudgetTierId = ValueOf<typeof ThematicPackageBudgetTierIds>;

// Uppercase while the preset tier ids are lowercase: the value is the API's, not a typo.
export const CUSTOM_BUDGET_TIER_CODE = 'CUSTOM';

export type ThematicPackageBudgetTierCode = ThematicPackageBudgetTierId | typeof CUSTOM_BUDGET_TIER_CODE;

export interface ThematicPackageBudgetTierResponse {
  id: ThematicPackageBudgetTierId;
  amount: number;
}

export interface ThematicPackageCustomBudgetResponse {
  isAvailable: boolean;
  minimumAmount: number;
  maximumAmount: number | null;
}

interface ThematicPackageUpsellNotEligibleResponse {
  isEligible: false;
}

interface ThematicPackageUpsellEligibleResponse {
  isEligible: true;
  budgetTiers: ThematicPackageBudgetTierResponse[];
  customBudget: ThematicPackageCustomBudgetResponse;
}

export type ThematicPackageUpsellResponse =
  | ThematicPackageUpsellNotEligibleResponse
  | ThematicPackageUpsellEligibleResponse;

export interface CampaignSubmitResponse {
  campaign: CampaignDetails;
  thematicPackageUpsell: ThematicPackageUpsellResponse;
}

export interface ThematicPackageUpsellNavigationState
  extends Pick<ThematicPackageUpsellEligibleResponse, 'budgetTiers' | 'customBudget'> {
  isUpsellFlowEntryAllowed: true;
}
